export default __webpack_public_path__ + "assets/48fdf53007435bf2c1ae05a670a5d2e8.jpeg";